import React from 'react';

const CategoryPage = ({ widgetCode }) => (
  <main style={{ padding: '2rem' }}>
    <h1>Service Widget</h1>
    <div dangerouslySetInnerHTML={{ __html: widgetCode }} />
  </main>
);

export default CategoryPage;